import React from "react";
import {  onlyNumbers} from "../common/keyValidation"

export class Model extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updateCost: "",
      errors:{
       validation: false,
       errorMessage : ""

      },

    }
  }
  componentDidMount() {
  
    let updateCost = this.props.cost;
    this.setState({
      updateCost
    })

  }

  clickOkay = () => {
    this.props.change(this.state.updateCost);
  }
  validateform =(value)=>{
  
    if(value.length<1){
      this.setState({
        errors:{
          validation:true,
          errorMessage:"Please enter valid input"
        }
      })
    }else{
      this.setState({
        errors:{
          validation:false,
          errorMessage:""

        }
      })
    }



  }

  handleChange = (e) => {
    let updateCost = e.target.value;
    this.setState({
      updateCost
    },()=> {
      this.validateform(this.state.updateCost)
    }
 
    )
  }
  
  render() {
    const{
      errors
    }=this.state
    return (

      <React.Fragment>
        {this.props.status &&
          <>
            <div className="modal fade in " id="editdata" role="dialog">
              <div className="modal-dialog">

                <div className="modal-content bill-model-design ">
                  {this.props.header &&
                    <div className="modal-header">
                      <h4 className="modal-title">{this.props.header ? this.props.header : ""}</h4>
                    </div>
                  }
                  <div className="modal-body mod-body">
                  <table class="modal-table-design">  
                  {this.props.page === "faxStatus" &&
                      this.props.text.map((item, id) =>{
                        return (
                          <>
                         
                            <tr key={id}>
                              <td style={{textAlign:"left"}}><label class="fw600">{(item.property === "TransactionID" ? "Transaction ID" : (item.property).match(/[A-Z][a-z]+|[0-9]+/g).join(" ") )}</label></td>
                              <td><label>{item.value}</label></td>
                            </tr>
                        
                         
                          </>
                        )
                      })

                  }
                   <tr>
                  {this.props.page !== "faxStatus" &&
                 <td>
                    <h5 className= {this.props.page === "facilityReg" ?  "modal-title mod-title epaperroadmodal" : "modal-title" }      >{this.props.text}</h5>
                    </td>
                }
                    {this.props.page === "costUpdate" &&
                    <>
                    <td>
                      <input type="text" onChange={this.handleChange} value={this.state.updateCost}  maxLength="10" onKeyPress={onlyNumbers}/>
                     
                      </td>
                      </>
                    }
                    {this.props.page === "hedisUpdate" &&
                    <>
                    <td>
                      <input type="text" onChange={this.handleChange}  value={this.state.updateCost} maxLength="10" onKeyPress={onlyNumbers}/>
                      
                      </td>
                      </>
                    }
                    </tr>
                    <tr>
                      <td></td>
                      <td> <label  style={{ color: "red" }}>{ errors.errorMessage}</label></td>
                    </tr>
                   </table>
                  </div>
                
                  <div className="model-btn text-center mb-3 pb-2">
                    {(this.props.page === "costUpdate" || this.props.page === "hedisUpdate") &&
                      <button type="button" disabled={errors.validation}className="btnDefault" onClick={this.clickOkay}  >Update</button>
             
                    }
                    
                    {this.props.page !== "costUpdate" && this.props.page !== "hedisUpdate"&&
                      <button type="button" className="btnDefault" onClick={this.props.confirmOkay}  >Ok</button>
                    }
                    {this.props.page !== "PatientRegister"  && this.props.page !== "facilityReg" && this.props.page !== "tracking" && this.props.page !== "faxStatus" &&
                      <button type="button" className="btnDefault" onClick={this.props.closePop} >Cancel</button>

                    }
                  </div>
                </div>



              </div>

            </div>
          </>
        }
      </React.Fragment>


    )
  }
}

export default Model;